import styled, { css } from 'styled-components';

export const BaseBubble = styled.div`
  position: relative;
  padding: 10px 20px;
  white-space: pre-line; /* ensure line breaks are implemented */
  position: relative;
  word-break: break-word;
  pointer-events: all;
  border-radius: ${({ theme }) => theme.borderRadius.md};
  background: ${(props) => props.theme.color.midnight}BB;
  color: #fff;
  margin: auto;
  text-align: left;
  font-size: 15px;
  font-weight: 400;
  line-height: 21px;
  max-height: 14svh;
  overflow: auto;
  user-select: text;
  &::-webkit-scrollbar {
    width: 0.6rem;
  }
  &::-webkit-scrollbar-track {
    background-color: ${(props) => props.theme.color.primaryLight};
    border-radius: ${(props) => props.theme.borderRadius.lg};
  }
  &::-webkit-scrollbar-thumb {
    border-radius: ${(props) => props.theme.borderRadius.lg};
    background-color: ${(props) => props.theme.color.primaryDark};
    cursor: pointer;
  }
`;

export const FloatingBubble = styled(BaseBubble)``;
